import EmailNotificationTextModal from './EmailNotificationTextModal';

export default EmailNotificationTextModal;


// WEBPACK FOOTER //
// ./src/features/organization/components/email-notification-text-modal/index.js